import type { ServerResponse } from "@/http"
import type { IGuestbookMessageResponse } from "@/types/message.interface"
import { axios } from "@/axios"
import { GuestbookMessage } from "@/models"

export async function updateMessage({ id, message }: GuestbookMessage, eventVaultId?: number) {
  if (!id) {
    throw new Error(
      "Missing `id` when attempting to update a guestbook message. Please ensure `message.id` is provided.",
    )
  }
  if (!eventVaultId) {
    throw new Error(
      "Missing `eventVaultId` when attempting to update a guestbook message. Please ensure `eventVaultId` is provided.",
    )
  }

  const response = await axios.patch<ServerResponse<IGuestbookMessageResponse>>(
    `/api/${eventVaultId}/messages/${id}`,
    {
      message,
    },
  )

  return response.data?.Data ? GuestbookMessage.fromResponse(response.data.Data!) : null
}
